import { Link } from "react-router-dom";
import { breakingTicker } from "@/mocks/news";

export default function BreakingTicker() {
  const items = [...breakingTicker, ...breakingTicker];
  return (
    <section
      aria-label="实时快讯"
      className="w-full bg-primary-950 text-background-100 border-y border-primary-900"
    >
      <div className="w-full flex items-stretch">
        <div className="flex items-center gap-2 px-4 md:px-8 py-3 bg-primary-500 text-background-50 shrink-0">
          <i className="ri-live-fill text-base" aria-hidden="true"></i>
          <span className="text-sm font-label font-bold whitespace-nowrap">快讯</span>
          <span className="hidden sm:inline text-xs font-label opacity-90 whitespace-nowrap">
            突发 · 插播
          </span>
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-gt-marquee hover:[animation-play-state:paused]">
            {items.map((text, index) => (
              <Link
                key={`${text}-${index}`}
                to="/dispatch/breaking"
                className="flex items-center gap-3 px-6 py-3 text-sm whitespace-nowrap text-background-100/90 hover:text-accent-300 transition-colors"
              >
                <span className="w-1.5 h-1.5 rounded-full bg-accent-400 shrink-0"></span>
                {text}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}